import RequestBuilder from "../RequestBuilder"
import {Method} from "../enum/Method"
import {PagedActivityJson} from "../json/PagedResponseJson";

export class ActivityRequests {
    static list(): Promise<PagedActivityJson> {
        return new RequestBuilder(Method.Get, `activities`).buildAndSend()
    }
}